"use client";

import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SplitOrderDetailContent from "./splitOrderDetailContent";

export default function SplitOrderDetailView() {
  const navigate = useNavigate();
	const location = useLocation();
	const recieptno = location.state?.recieptno || null;

  return <SplitOrderDetailContent navigate={navigate} recieptno={recieptno} />;
}
